<template>
  <b-form @submit.prevent>
    <b-row>
      <b-col md="6">
        <b-form-group
            label="ID Avito"
            label-for="avito_id"
        >
          <b-form-input
              :class="{'is-invalid' : form_errors.avito_id}"
              v-model="area.avito_id"
              id="avito_id"
              placeholder="ID Avito"
          />
          <small v-if="form_errors.avito_id" class="text-danger">{{ form_errors.avito_id[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="Nom"
            label-for="libelle"
        >
          <b-form-input
              :class="{'is-invalid' : form_errors.libelle}"
              v-model="area.libelle"
              id="libelle"
              placeholder="Nom de la zone"
          />
          <small v-if="form_errors.libelle" class="text-danger">{{ form_errors.libelle[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-button
            type="submit"
            variant="primary"
            class="mr-1"
            @click="submit"
        >
          Enregistrer
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'AvitoAreaForm',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    initialArea: {
      default: false,
    }
  },
  methods: {
    submit() {
      let _this = this;
      _this.form_errors = {};
      
      const action = this.area.id 
        ? 'siteModule/updateAvitoArea'
        : 'siteModule/storeAvitoArea';
      
      this.$store.dispatch(action, this.area).then(function (response) {
        _this.$emit('submitted', response);
        _this.$router.push('/avito-areas');
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          _this.form_errors = error.response.data.errors;
        }
      });
    }
  },
  created() {
    this.area = this.initialArea ? {...this.initialArea} : {
      avito_id: '',
      libelle: ''
    };
  },
  data() {
    return {
      area: {
        avito_id: '',
        libelle: ''
      },
      form_errors: {}
    }
  },
}
</script>
